import { DienstleistungsModule } from './dienstleistungsmodule.enum';
import { DienstleistungsModuleBeschreibung } from './dienstleistungsmodulebeschreibung.model';

export class DienstleistungsArt {
    public id: number;
    public title: string;
    public notes?: string;
    public dienstleistungsmodule: DienstleistungsModule[];
    public dienstleistungsmoduleBeschreibung?: DienstleistungsModuleBeschreibung[]; // dynamically added to get a valid description
    public lastChanged: string;

    constructor() {
        this.dienstleistungsmodule = [];
    }
}
